module.exports = __webpack_public_path__ + "img/38.8411d85c.jpg";